import { render, staticRenderFns } from "./fold-icon.vue?vue&type=template&id=16e1ca56&scoped=true"
import script from "./fold-icon.vue?vue&type=script&lang=js"
export * from "./fold-icon.vue?vue&type=script&lang=js"
import style0 from "./fold-icon.vue?vue&type=style&index=0&id=16e1ca56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e1ca56",
  null
  
)

export default component.exports